import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Raven from 'raven-js';

import OTPVerify from '../../features/otp-verify';
import EmailVerificationLink from '../../features/email-verification-link';
import AuthManager from '../../../shared/services/AuthManager';

class EmailVerification extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
      state: PropTypes.object,
    }).isRequired,
    pageHeading: PropTypes.string,
    forMobile: PropTypes.bool,
  };

  componentWillMount() {
    const {state: historyState} = this.props.location;
    let {user, allowSkip, signup, userEmail, useMobile } = historyState;
    this.fullToken = AuthManager.getFullToken();
    if (!historyState) {
      this.props.history.replace('/account');
    }
    this.allowSkipping = allowSkip === undefined || allowSkip;
    this.allowSkipping = this.allowSkipping && (!userEmail || user.email === userEmail);
    this.signup = signup;
    if (user && useMobile && !user.emailVerified && user.mobileVerified) {
      this.allowSkipping = false;
    }
    Raven.setUserContext({
      fullToken: this.fullToken,
      user: user,
      state: this.state,
      props: this.props,
      allowSkipping: this.allowSkipping,
      allowSkip: allowSkip
    });
  }

  getRedirectionLocation() {
    const {state: historyState} = this.props.location;
    return {
      pathname: historyState.redirectTo.shift(),
      state: {
        ...historyState,
      },
    };
  }

  render() {
    if (!Boolean(this.allowSkipping)) {
      return <OTPVerify {...this.props} skipAllowed={this.allowSkipping}/>
    } else if (this.allowSkipping && this.signup) {
      return <EmailVerificationLink {...this.props} />
    } else {
      this.props.history.replace(this.getRedirectionLocation());
      return <div/>
    }
  }
}

export default connect()(EmailVerification);